<template>
  <div class="home _resumen" :style="mobileBodyHeight">
    <Header />
    <div ref="bodyRef_" class="mx-auto my-5 xs:my-0 xs:mx-0 md:mx-0 md:container xl:container lg:container xs:w-full sm:w-full xl:p-10 xs:flex sm:flex xs:flex-col sm:flex-col">
        <CheckoutNavigation :step="2"/>
        <div class="flex mt-5 justify-center">
          <div class="w-6/12 xs:w-full sm:w-full md:w-full">
            <Resumen />
          </div>
        </div>
    </div>
    <Footer /> 
  </div>
</template>

<style scoped>
  @media only screen and (min-width:768px) and (max-width:991px) { 
    .home._resumen {
      min-height:100vh !important
    }
  }
</style>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import CheckoutNavigation from '@/components/checkout/Navigation.vue'
import Resumen from '@/components/checkout/Resumen.vue'
import Footer from '@/components/Footer.vue'
import { mapGetters, useStore } from 'vuex';
import { inject, onUnmounted, onMounted } from '@vue/runtime-core'
import { ref, isRef } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'Home',
  components: {
    Header,
    CheckoutNavigation,
    Footer,
    Resumen
  },
  computed: {
    ...mapGetters({
      mobileBodyHeight: 'GET_MOBILE_BODY_HEIGHT'
    })
  },
  setup(){
    const bodyRef_ = ref(0)
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const currentMediaQuery_ = inject('mq')
    
    console.log('🔍 Resumen View - Route params:', route.params);
    console.log('🔍 Resumen View - Route query:', route.query);
    
    /* eslint-disable */
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {'send_to': 'AW-10798387531/rVJZCImv74ADEMuiiZ0o'}); 
    }
    /* eslint-enable */

    // Capturar parámetros de pago exitoso
    const capturePaymentData = () => {
      try {
        // Decodificar la URL por si viene con &amp; en lugar de &
        const cleanQuery = {};
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
          cleanQuery[key] = value;
        });

        const transactionId = route.params.transactionId || null
        const resultIndicator = cleanQuery.resultIndicator || route.query.resultIndicator || null
        const sessionVersion = cleanQuery.sessionVersion || route.query.sessionVersion || null
        const checkoutVersion = cleanQuery.checkoutVersion || route.query.checkoutVersion || null

        console.log('📦 Datos capturados:', {
          transactionId,
          resultIndicator,
          sessionVersion,
          checkoutVersion
        });

        if (transactionId && resultIndicator) {
          console.log('✅ Pago exitoso detectado');
          console.log('Transaction ID:', transactionId);
          console.log('Result Indicator:', resultIndicator);
          console.log('Session Version:', sessionVersion);
          console.log('Checkout Version:', checkoutVersion);

          // Guardar en store para uso posterior
          store.commit('SET_PAYMENT_TRANSACTION', {
            transactionId,
            resultIndicator,
            sessionVersion,
            checkoutVersion,
            timestamp: new Date().toISOString()
          });

          // Limpiar URL sin recargar la página
          const currentPath = route.path.split('?')[0].replace(/\/[^\/]+$/, '');
          console.log('🧹 Limpiando URL a:', currentPath);
          router.replace(currentPath);
        } else {
          console.log('ℹ️ No hay datos de transacción en la URL');
        }
      } catch (error) {
        console.error('❌ Error capturando datos de pago:', error);
      }
    };

    onMounted(() => { 
      console.log('🚀 Resumen View montado');
      
      // El handleCallback se ejecuta en el componente Resumen.vue
      if (!window.location.search.includes('resultIndicator')) {
        capturePaymentData();
      }
      
      const currentMediaQuery = currentMediaQuery_.current
      const bodyRef = bodyRef_.value
      const bodyIsRef =  isRef(bodyRef_)
      store.commit('SET_MOBILE_BODY_HEIGHT', {currentMediaQuery, bodyRef, bodyIsRef})        
    })
    onUnmounted(() => {
      store.commit('STOP_INTERVAL_MOBILE', true)
    })
    return {currentMediaQuery_, bodyRef_} 
  }
}
</script>
